import { toVueComponent } from "@scalar-org/vue-render";
import { html } from "../../helpers/html-template.js";
import { safeCompute } from "../../helpers/safe-compute.js";
import { EditorClasses } from "../../styles.js";
import { getIframeAttributes } from "./validate-src.js";
function guideEmbedHtml(props) {
  const embedClasses = [EditorClasses.Embed, "highlight-active"];
  const iframeAttributes = safeCompute({
    method: () => getIframeAttributes(props.src),
    fallback: ""
  });
  return html`
<figure class="${embedClasses.join(" ")}" alt="${props.alt}">
  <iframe ${iframeAttributes} ></iframe>
  ${props.caption?.length ? html`<figcaption>${props.caption}</figcaption>` : html`<figcaption><ssg-children/></figcaption>`}
</figure>
  `;
}
const ScalarEmbedVue = toVueComponent(guideEmbedHtml, {
  src: String,
  caption: String,
  alt: String
});
export {
  ScalarEmbedVue,
  guideEmbedHtml
};
//# sourceMappingURL=component.js.map
